import {Configuration} from 'hemwb-api/dist/runtime';
import {getAPIBaseURL} from '../components/auth/utils';

export const configuration = new Configuration({
  basePath: getAPIBaseURL() + '/api/v2',
  //basePath: 'http://localhost:11000/api/v2',
  //basePath: 'https://api-test.merck.com/hemrepository/v1/api/v2', // Old PCF: https://hemrepository-dev-be.apps.americas-tst.cf.webappsp.com/api/v2
  credentials: 'include',
});
